import { Fragment } from "react";
import { Toolbar } from "@mui/material";
import Header from "../HeaderComponents/Header";
import Sidebar from "../HeaderComponents/Sidebar";
import Footer from "../Footer/Footer";
import { ToastContainer } from "react-toastify";

export default function AppLayout({
  children,
  sidebarOpen,
  toggleSidebar,
  handleCloseSideBar,
}) {
  return (
    <div className="App">
      <Header toggleSidebar={toggleSidebar} />
      <Toolbar sx={{ minHeight: "80px", flexShrink: 0 }} />
      <Sidebar open={sidebarOpen} onClose={handleCloseSideBar} />
      <ToastContainer position="top-right" autoClose={3000} newestOnTop />
      <main className="app-content">
        <Fragment>{children}</Fragment>
      </main>
      <Footer />
    </div>
  );
}
